import React, { useState, useEffect } from 'react'
import { ChromePicker } from 'react-color'
import PropTypes from 'prop-types'
import './ColorPicker.scss'

function ColorPicker(props) {
  const { colorPickerObj, displayLeft, handleColorChange } = props
  const [displayColorPicker, setDisplayColorPicker] = useState(false)
  const [selectedColor, setSelectedColor] = useState(colorPickerObj.defaultColor)
  const [prevSelectedColor, setPrevSelectedColor] = useState(colorPickerObj.defaultColor)

  useEffect(() => {
    if (selectedColor !== colorPickerObj.defaultColor) {
      setSelectedColor(colorPickerObj.defaultColor)
      setPrevSelectedColor(colorPickerObj.defaultColor)
    }
  }, [colorPickerObj.defaultColor])

  const changeColor = (rgb, key) => {
    const rgbColor = `rgb(${rgb.r},${rgb.g},${rgb.b},1)`
    setSelectedColor(rgbColor)
    handleColorChange(rgbColor, key)
  }

  const saveColor = key => {
    setPrevSelectedColor(selectedColor)
    setDisplayColorPicker(false)
    handleColorChange(selectedColor, key, true)
  }

  const updatePrevColor = obj => {
    setSelectedColor(prevSelectedColor)
    setDisplayColorPicker(false)
    if (selectedColor !== prevSelectedColor) {
      handleColorChange(prevSelectedColor, obj.key, false)
    }
  }

  const colorPickerButtonStyles = {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    border: '1px solid #757575',
    backgroundColor: `${selectedColor}`,
    outline: 'none',
    cursor: 'pointer',
    alignSelf: 'start'
  }

  return (
    <div className="container">
      <div className="color-picker-button row">
        <button style={colorPickerButtonStyles} onClick={() => setDisplayColorPicker(!displayColorPicker)} data-testid={`color-picker-button-${colorPickerObj.key}`}></button>
        <span className="option-name">{colorPickerObj.name}
        { colorPickerObj.subName && <div className="option-subname">{colorPickerObj.subName}</div>}
        </span>
      </div>
      {displayColorPicker ? <div className={displayLeft ? 'popoverLeft' : 'popoverRight'} data-testid="popover">
      <div className="cover" data-testid="cover-button" onClick={ () => updatePrevColor(colorPickerObj) }/>
        <ChromePicker
          inputProps={{
            'data-testid': 'chromepicker-selected'
          }}
          color={selectedColor}
          onChangeComplete={color => changeColor(color.rgb, colorPickerObj.key)}
          disableAlpha={true}
        />
        <div className="action-buttons-group">
          <button className="action-button cancel" data-testid="color-picker-cancel-btn" onClick={() => updatePrevColor(colorPickerObj)}>Cancel</button>
          <button className="action-button ok" data-testid="color-picker-ok-btn" onClick={() => saveColor(colorPickerObj.key)}>Ok</button>
        </div>
      </div> : null}
    </div>
  )
}

ColorPicker.propTypes = {
  colorPickerObj: PropTypes.shape({
    name: PropTypes.string,
    subName: PropTypes.string,
    key: PropTypes.string,
    defaultColor: PropTypes.string
  }),
  displayLeft: PropTypes.bool,
  handleColorChange: PropTypes.func
}
export default ColorPicker
